// extracted by mini-css-extract-plugin
module.exports = {"pageRow":"PageRow_pageRow__3KvG7","text":"PageRow_text__3hkFP","pageCounter":"PageRow_pageCounter__1kibz","checkbox":"PageRow_checkbox__2pxrW"};